// import Tooltip from "@ui/external/components/tooltip";
import Tooltip from "@ui/external/components/tooltip";
import { ColumnType } from "@utils/interface/index.interface";

type CricketUserDetails = {
  id: number;
  course: {
    id: number;
    title: string;
  };
  full_name: string;
  display_name: string;
  email: string;
  phone_number: string;
  created_date: string;
  created_date_time: string;
  updated_date_time: string;
};

const ColumnList = () => {
  const column: ColumnType<CricketUserDetails>[] = [
    {
      name: "SN",
      cell: (row) => (
        <span className="font-semibold text-gray-700">{row.id}</span>
      ),
      sortable: true,
    },
    {
      name: "Full Name",
      cell: (row) => <p>{row?.full_name}</p>,
      sortable: true,
    },
    {
      name: "Email",
      cell: (row) => <p>{row?.email}</p>,
      sortable: false,
    },
    {
      name: "Phone No.",
      cell: (row) => <p>{row?.phone_number}</p>,
      sortable: false,
    },
    {
      name: "Course",
      cell: (row) => (
        <div className="w-50 truncate">
          <Tooltip description={row?.course?.title || ""}>
            <div className="text-lg capitalize  max-w-[150px] w-fit truncate font-semibold text-gray-800">
              <span className="">{row?.course?.title || ""}</span>
            </div>
          </Tooltip>
        </div>
      ),
      sortable: false,
    },
  ];
  return column;
};

export { ColumnList };
